import { render, staticRenderFns } from "./About_bak.vue?vue&type=template&id=030aaffe&"
import script from "./About_bak.vue?vue&type=script&lang=js&"
export * from "./About_bak.vue?vue&type=script&lang=js&"
import style0 from "./About_bak.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports